import globalstorage from "../global/GlobalStrorage";
import Apiweb from "./webapibase";
//import Api from "./api";
export default {
  userAthenticate(loginid, password) {
    let apiurl = "api/GlobalUM/userauthenticate/?strusername=" + loginid + "&strpsd=" + password + "";
    //alert(apiurl);
    return Apiweb.get(apiurl);
  },
  getclinetsbyuserid(){
    let apiurl = "api/GlobalUM/getclinetinfobyuserid/?userid="+ globalstorage.getloginuserid() ;
    return Apiweb.get(apiurl);

  },
  getsessionlistbydate(varstrdate,varclinetid){
    let apiurl = "api/SessionInfo/getclinetsessioninfo/?strdate="+varstrdate+"&clinetid="+ varclinetid;
    //alert(apiurl);
    return Apiweb.get(apiurl);

  },
  gettransactionbysession(varsessionid,varclinetid){
    let apiurl = "api/SessionInfo/gettransactioninfo/?strsessionids="+varsessionid+"&clinetid="+ varclinetid;
    //alert(apiurl);
    return Apiweb.get(apiurl);

  },
  userExtraAthenticate(user_id, key, app_id) {
    // alert('ddd');
    let apiurl = "applogin/?user_id=" + user_id + "&key=" + key + "&app_id=" + app_id + "";
    //alert(apiurl);
    return Apiweb.get(apiurl);
  },
  getloginuserapps(userid) {

    let apiurl = "user_app_url/?user_id=" + userid;
    //alert(apiurl);
    return Apiweb.get(apiurl);
  },
  getuserbyuserid(userid) {

    let apiurl = "user/?id=" + userid;
    //alert(apiurl);
    return Apiweb.get(apiurl);
  },
  changeuserpassword(userid, newpswd) {

    let apiurl = "user/?id=" + userid + "&password=" + newpswd;
    //let apiurlnew = "user/?" + "id="+userid+"&username="+ username +"&password="+ password +"&loginid="+ loginid +"&createdby="+ createdby +"&isactive="+ isactive +"&canshare=" +canshare;
    //alert(apiurl);
    return Apiweb.get(apiurl);
  },
  testapi() {
    let apiurl = "WeatherForecast";
    return Apiweb.get(apiurl);
  }
}